import {Button, Divider, Layout, Tabs, Typography} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import BAN from './BAN';
import EGA from './EGA';
import IAA from './IAA';
import IBS from './IBS';

const {Paragraph, Text} = Typography;
const Content = Layout;

const ModTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);
  const [Tno, setTno] = useState(appColors['ColorX']);
  const [Gno, setGno] = useState(appColors['ColorG2']);
  const [To, setTo] = useState(appColors['ColorX']);
  const [Go, setGo] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTUno('white');
      setGUno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'tres') {
      setTno('white');
      setGno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'cuatro') {
      setTo('white');
      setGo(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
    }
  };
  const items_ = [
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>Incubation of<br/> aptamers with<br/> AuNPs</Button>, key: 'uno', children: <IAA/>},
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Electrophoresis<br/> gel with AuNPs</Button>, key: 'dos', children: <EGA/>},
    {label: <Button style={{width: '22vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: Tno, fontWeight: 'bold', borderColor: Gno, background: Gno}}>Interaction of<br/>biotin-streptavidin</Button>, key: 'tres', children: <IBS/>},
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: To, fontWeight: 'bold', borderColor: Go, background: Go}}>Binding<br/> aptamers to<br/> nitrocellulose</Button>, key: 'cuatro', children: <BAN/>},
  ];
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Paragraph className= 'Title3' style={{color: appColors['ColorX']}}>Modifications of the aptamers</Paragraph>
      <Text className='BaseText'>After knowing that our aptamer had the appropriate affinity and specificity towards CRP. The second phase of our experimental pipeline is to show that the modifications we proposed for the aptamers are properly done, and if the aptamers modified with thiol bound correctly to the AuNPs and if the biotinylated aptamers bound correctly to the streptavidin. For this purpose we proposed the following protocols: Incubation of aptamers with AuNPs, electrophoresis gel with AuNPs, interaction between aptamer modified with biotin and streptavidin, and binding aptamers to the nitrocellulose membrane.</Text>
      <Content style={{padding: '0 2vh 2vh 2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='3vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
      <Divider/>
    </Layout>
  );
};

export default ModTabs;
